export default {
  canSeePlanInfo(state) {
    if (state.userPermissions && state.userPermissions.length) {
      return !state.userPermissions.includes('view-plan-denied')
    }
    return false
  },
  creditsLoading: state => state.credits?.loading ?? false,
  creditsBalance: state => state.credits?.balance ?? 0,
  formatCreditsBalance: (state) => (maxLength = 6) => {
    const currency = state.credits.currency || state.userPlanInfo?.currency
    const locale = currency === 'usd' ? 'en-US' : 'pt-BR'

    const balance = Math.floor(state.credits.balance).toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    const cleanBalance = balance.replace(/[.,]/g, '')
    return cleanBalance.length > maxLength ? `${cleanBalance.slice(0, maxLength)}...` : balance
  },
  userCurrency: (state) => {
    return state.credits.currency || state.userPlanInfo?.currency
  },
  userLimit: (state) => state.userPlanInfo?.limit,
  hasEditVideoPerm: (state) => {
    return state.userPermissions?.includes('put-video') ?? false
  }
}
